import { render, staticRenderFns } from "./priceMaintenanceDialog.vue?vue&type=template&id=447fedff&scoped=true"
import script from "./priceMaintenanceDialog.vue?vue&type=script&lang=js"
export * from "./priceMaintenanceDialog.vue?vue&type=script&lang=js"
import style0 from "./priceMaintenanceDialog.vue?vue&type=style&index=0&id=447fedff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447fedff",
  null
  
)

export default component.exports